<template>
  <el-table
    :data="messages">

    <el-table-column
        prop="messageId"
        label="ID"
        width="200">
    </el-table-column>

    <el-table-column
        width="100"
        prop="createdAt"
        label="記録日時">
      <template #default="{row}">{{ formatDateTime(row.createdAt) }}</template>
    </el-table-column>

    <el-table-column
        prop="tradeContract.name"
        label="契約名">
    </el-table-column>

    <el-table-column
        prop="receiverOwner.name"
        label="取引先名">
    </el-table-column>

    <el-table-column
        prop="recordCount"
        label="レコード数"
        width="120">
      <template #default="{row}">{{ formatNumber(row.recordCount) }}</template>
    </el-table-column>

    <el-table-column
        prop="byteCount"
        label="バイト数"
        width="120">
      <template #default="{row}">{{ formatNumber(row.byteCount) }}</template>
    </el-table-column>

    <el-table-column
        width="100"
        prop="sendTypeServiceRecordCreatedAt"
        label="送信日時">
      <template #default="{row}">{{ formatDateTime(row.sendTypeServiceRecordCreatedAt) }}</template>
    </el-table-column>

    <el-table-column
        width="100"
        prop="deleteTypeServiceRecordCreatedAt"
        label="削除日時">
      <template #default="{row}">{{ formatDateTime(row.deleteTypeServiceRecordCreatedAt) }}</template>
    </el-table-column>

    <el-table-column
        width="70"
        align="right"
        fixed="right">
      <template #default="{row}">
        <icon-btns>
          <icon-btn
              type="view"
              :to="{ name: alterRouteName('MessageShow'), params: { dataImplementationId: dataImplementationId, messageId: row.messageId, messageHistoryId: row.id } }">
          </icon-btn>
        </icon-btns>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import PathInfoMixin from "@/router/PathInfoMixin";
import Formatter from "@/utils/Formatter";
import IconBtns from "@/components/molecules/IconBtns";
import IconBtn from "@/components/molecules/IconBtn.vue";

export default {
  name: 'MessageTable',
  components: {IconBtn, IconBtns},
  mixins: [
    PathInfoMixin,
    Formatter
  ],
  props: {
    messages: {
      type: Array,
      required: true
    },
    dataImplementationId: {
      type: String,
      required: true
    }
  }
}
</script>
